import React from 'react';

/**
 * SaveStatus component for displaying the current save status
 * 
 * @param {Object} props - Component props
 * @param {string} props.status - Current save status ('saving', 'saved', 'error', or null)
 * @returns {JSX.Element|null} SaveStatus component or null if no status
 */
const SaveStatus = ({ status }) => {
  // Only show errors, hide "saving" and "saved" statuses
  if (!status || status === 'saving' || status === 'saved') return null;
  
  const getStatusText = () => {
    switch (status) {
      case 'error':
        return 'Error saving!';
      default:
        return '';
    }
  };
  
  return (
    <div className={`save-status ${status}`}>
      {getStatusText()}
    </div>
  );
};

export default SaveStatus; 